import { Directive, EventEmitter, Output } from '@angular/core';
import { SidebarState } from '../contract/sidebar-state.contract';

@Directive()
export abstract class BaseSidebarStateDirective {
  @Output() state = new EventEmitter<SidebarState>();
  public sidebarState: SidebarState = 'collapsed'; // or a more suitable initial value

  emitStateChange(newState: SidebarState) {
    this.sidebarState = newState;
    this.state.emit(newState);
  }
}
